import React from 'react';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { Field, TextOutput, NumericInput, RadioGroup } from 'Components/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import externalTestMethods from '../../../ExternalTestMethods';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { ParticleDensityDeterminationMethod } from '../../types';
import { hasValue } from 'Lib/Any';

let AsTestFractionParticleDensitySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const particleDensityDeterminationMethod = useSelector(
    pipe(createWorksheetSelector!('TestFractionParticleDensity.ParticleDensityDeterminationMethod'))
  ) as ParticleDensityDeterminationMethod;
  const particleDensityHasValue = useSelector(
    pipe(createWorksheetSelector!('TestFractionParticleDensity.ParticleDensity'), hasValue)
  );
  return (
    <>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name={'TestFractionParticleDensity.ParticleDensityDeterminationMethod'}
          options={[
            { label: 'Assumed', value: ParticleDensityDeterminationMethod.Assumed },
            { label: 'Measured', value: ParticleDensityDeterminationMethod.Measured },
            { label: 'Calculated From Curve', value: ParticleDensityDeterminationMethod.CalculatedFromCurve },
          ]}
          confirm={() =>
            (particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Assumed ||
              particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Measured) &&
            particleDensityHasValue
          }
          confirmText="The particle density determination method will be changed, overwriting any existing data."
        />
        <FieldSet>
          <Field
            input={<TextOutput />}
            name="TestFractionParticleDensity.ParticleDensity"
            visible={particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.CalculatedFromCurve}
          />
          <Field
            input={<NumericInput />}
            name="TestFractionParticleDensity.ParticleDensity"
            visible={particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Assumed}
          />
        </FieldSet>
      </ListFieldSection>
      {particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Measured && (
        <WorksheetAssociatedTestSection
          name="TestFractionParticleDensity.AssociatedTestFractionParticleDensity"
          heading="Test Fraction Particle Density - External source (final results only)"
          testType="Particle Density"
          associatedTestModel={{
            external: {
              testMethods: [externalTestMethods.particleDensity.AS_1289_3_5_1],
              permitOtherTestMethods: false,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    name="TestFractionParticleDensity.AssociatedTestFractionParticleDensity.ExternalTest.Results.ParticleDensity"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </>
  );
};

AsTestFractionParticleDensitySection = withInjectedProps(AsTestFractionParticleDensitySection);

export { AsTestFractionParticleDensitySection };
export default AsTestFractionParticleDensitySection;
